import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { KgInput, CurrencyInput, CurrencyDisplay, KgDisplay } from "../../../Utils/Inputs";

export default function SKIMTableRow(props) {
    const { rowName, rowIndex, month, monthIndex, isFirstTable } = props;

    const { control } = useFormContext();

    const kgSecos = useWatch({
        control,
        name: `ComparativoCostoMP.SKIMData.${rowName}.${month}.KgSecos`,
    })
    const costoKgSec = useWatch({
        control,
        name: `ComparativoCostoMP.SKIMData.${rowName}.${month}.CostoKgSec`,
    });
    const total = (kgSecos * costoKgSec).toFixed(2);

    // CASOS ESPECIALES
    // INVENTARIO INICIAL PARA MESES POSTERIORES A ENERO
    if (!isFirstTable && rowName === 'InventarioInicial') {
        return (
            <tr key={rowIndex}>
                <td><KgDisplay value={kgSecos} /></td>
                <td><CurrencyDisplay value={costoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={total} /></td>
            </tr>
        )
    }
    // (+) Del mes
    if (rowName === 'DelMes') {
        return (
            <tr key={rowIndex}>
                <td><KgDisplay value={kgSecos} /></td>
                <td><CurrencyDisplay value={costoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={total} /></td>
            </tr>
        )
    }

    return (
        <tr key={rowIndex}>
            <td>
                <KgInput
                    control={control}
                    name={`ComparativoCostoMP.SKIMData.${rowName}.${month}.KgSecos`} />
            </td>
            <td>
                <CurrencyInput
                    control={control}
                    name={`ComparativoCostoMP.SKIMData.${rowName}.${month}.CostoKgSec`}
                    decimalScale={5} />
            </td>
            <td><CurrencyDisplay value={total} /></td>
        </tr>
    );
}
